import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import ArrowRightImage from "../../Images/ArrowRightImage.png";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";
import Pagination from "@mui/material/Pagination";

export default function ProfileOrderHistory() {
  const { t, i18n } = useTranslation();
  const [OrderData, setOrderData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const history = useHistory();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  const user = JSON.parse(localStorage.getItem("user"));

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = MyWidth <= 1024 ? 2 : 4;

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchData = async () => {
    setLoading(false);
    const data = { UserId: user?.userId };
    try {
      const response = await axios.post(
        `${MyDomain}Orders/GetUserOrders`,
        data
      );
      setOrderData(response.data);
      setLoading(true);
    } catch (err) {
      setLoading(true);
      console.log(err.response?.data);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDivClick = (theorder) => {
    history.push(`/orderd-details/${theorder.order.id}`);
  };

  const totalPages = Math.ceil(OrderData.length / itemsPerPage);
  const paginatedOrders = OrderData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: MyWidth <= 1024 ? "0%" : "10%",
        }}
      >
        <div style={{ paddingTop: 50 }}>
          <p style={{ fontWeight: 500, fontSize: 25, marginLeft: 10 }}>
            {t("profile.Yourorders")}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            maxHeight: MyWidth <= 1024 ? 400 : 600,
            overflowY: "scroll",
          }}
        >
          {Loading ? (
            <>
              {OrderData.length === 0 ? (
                <div style={{ paddingLeft: 20, paddingTop: 20 }}>
                  <a style={{ fontSize: 12 }}>{t("profile.Noordersfound")}</a>
                </div>
              ) : (
                <>
                  {paginatedOrders.map((product, index) => (
                    <div
                      key={index}
                      onClick={() => handleDivClick(product)}
                      style={{
                        display: "flex",
                        border: "1px solid black",
                        marginBottom: 10,
                        width: "100%",
                        justifyContent: "space-between",
                        padding: 10,
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          //maxWidth: "40%",
                        }}
                      >
                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.Orderid")}:{" "}
                          <span style={{ backgroundColor: "#f4f4f5" }}>
                            {product.order.id}
                          </span>
                        </a>
                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.Totalprice")}: ₪
                          {product.order.price}
                        </a>

                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.Dateorder")}:
                          {product.order.dateOrder}
                        </a>
                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.Timeorder")}:{" "}
                          {product.order.timeOrder}
                        </a>
                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.paymenttype")}:{" "}
                          {product.order.paymentType === 1
                            ? t("profile.Cash")
                            : t("profile.CreditCard")}
                        </a>
                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.Fullname")}:{" "}
                          {product.addresses.firstName}{" "}
                          {product.addresses.lastName}
                        </a>
                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.Phonenumber")}:{" "}
                          {product.addresses.phonenumber}
                        </a>
                        <a style={{ fontSize: 14, fontWeight: "bold" }}>
                          {t("profileOrderHistory.city")}:{" "}
                          {product.addresses.city}
                        </a>
                      </div>
                      {/* <div style={{ display: "flex", flexDirection: "column" }}>
                        <a style={{ fontSize: 14 }}>
                          {t("profileOrderHistory.Fullname")}:{" "}
                          {product.addresses.firstName}{" "}
                          {product.addresses.lastName}
                        </a>
                        <a style={{ fontSize: 14 }}>
                          {t("profileOrderHistory.Phonenumber")}:{" "}
                          {product.addresses.phonenumber}
                        </a>
                        <a style={{ fontSize: 14 }}>
                          {t("profileOrderHistory.city")}:{" "}
                          {product.addresses.city}
                        </a>
                      </div> */}
                      <div
                        style={{
                          maxWidth: "20%",
                          opacity: 0.5,
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        {/* <img
                          src={ArrowRightImage}
                          alt="Arrow"
                          style={{
                            width: "50%",
                            height: "auto",
                            objectFit: "cover",
                          }}
                        /> */}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </>
          ) : (
            <>loading...</>
          )}
        </div>

        {/* Pagination below the scroll area */}
        {OrderData.length > itemsPerPage && (
          <div
            style={{ marginTop: 20, display: "flex", justifyContent: "center" }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, value) => {
                setCurrentPage(value);
                //window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              color="primary"
            />
          </div>
        )}
      </div>
    </div>
  );
}
